'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import cx from 'classnames';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '@components/typography';
import { sectionHeadingClassName } from './styles';

// prettier-ignore
const faqs = [{
  question: 'How is Savvy different from other vacation rental sites?',
  answer: 'Savvy lowers travel costs and gives guests peace of mind. By not charging platform service fees, guests typically save 15-20% over the same property on other sites. Savvy also exclusively lists properties hosted by professional property management companies, so guests know a professional host is available to ensure a worry-free stay.'
}, {
  question: 'What are the benefits of listing on Savvy?',
  answer: 'Savvy is the first OTA built specifically for hosts by hosts. You keep full control over your policies and a direct relationship with your guests. You own the booking and are the merchant of record, so you can handle hospitality and any issues directly. Listings are free, and optional Premium upgrades let you control your placement in search results for a low, flat cost.'
}, {
  question: 'What rates should I list?',
  answer: 'Your book direct rates. We don’t charge transaction fees or traveler booking fees, so your direct pricing is competitive while you keep more margin. You pay 5% (vs 5-25% on OTAs) per confirmed booking, billed monthly, and you maintain complete control of the booking: your PMS, your data, your guest relationships.'
}, {
  question: 'How hard is it to onboard?',
  answer: 'If you’re on one of our partner PMS platforms, you can onboard in minutes. Enter your company details, connect your PMS, and your listings go live. No manual updates after that. Most hosts call it the easiest onboarding they’ve done.'
}, {
  question: 'When do I pay the 5%?',
  answer: 'You pay 5% per confirmed booking, billed monthly. There are no mandatory fees beyond that. Savvy also generates revenue through optional Premium listing upgrades for hosts who want increased visibility.'
}, {
  question: 'Can I use Savvy alongside Airbnb and Vrbo?',
  answer: 'Absolutely. Savvy integrates directly with your PMS, so your availability, rates, and calendar stay synced across all platforms. There’s no exclusivity requirement. Savvy is designed to complement your existing distribution strategy while giving you a lower-cost, direct booking channel.'
}];
export const FaqsSection: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="title4" component="h2" className={cx("text-center", sectionHeadingClassName)}>FAQs</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="w-full bg-white"><div className="mx-auto flex w-full max-w-[950px] flex-col items-center px-4 py-16 text-primary-main sm:px-8 sm:py-20">{t0}<div className="mt-8 flex w-full flex-col gap-4 sm:mt-12">{faqs.map(_temp)}</div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(item) {
  return <Disclosure key={item.question} as="div" className="rounded-lg bg-off-white">{t0 => {
      const {
        open
      } = t0;
      return <><Typography component="h3" variant="body1"><DisclosureButton className="flex w-full items-center justify-between gap-4 rounded-lg p-4 text-left !text-lg !font-semibold !leading-7 text-primary-main focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-main">{item.question}<FontAwesomeIcon icon={faChevronDown} className={cx("h-4 w-4 flex-shrink-0 text-primary-main transition-transform duration-300", {
              "rotate-180": open
            })} /></DisclosureButton></Typography><DisclosurePanel><Typography component="p" variant="body1" className="px-4 pb-4 !text-base !leading-6 text-primary-main">{item.answer}</Typography></DisclosurePanel></>;
    }}</Disclosure>;
}